import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    quiktips: [],
    quiktip: null,
    links: null,
    meta: null,
    filter: {
      keyword: null,
      productCategoryId: null,
      productId: null,
      buId: null,
      buIds: [],
    },
    tabs: [],
  },
  mutations: {
    CLEAR_ALL(state) {
      state.filter = {
        keyword: null,
        productCategoryId: null,
        productId: null,
        buId: null,
        buIds: [],
      };
      state.quiktips = [];
      state.quiktip = null;
    },
    SET_QUIKTIPS(state, data) {
      state.quiktips = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_QUIKTIP(state, data) {
      state.quiktip = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_TABS(state, detail) {
      state.tabs = detail;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },
    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setQuikTip({ commit }, data) {
      commit('SET_QUIKTIP', data);
    },
    find({ commit, state }) {
      let url = `/quiktips?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          if (response.body && response.body.data) {
            response.body.data.map(typeAs('QuikTip'));
          }
          return response.body;
        })
        .then((response) => {
          commit('SET_QUIKTIPS', response);
        });
    },
    findById({ commit }, id) {
      return http(`/quiktips/${id}`)
        .then((response) => response.body)
        .then(typeAs('QuikTip'))
        .then((item) => {
          commit('SET_QUIKTIP', item);
        });
    },
    destroy(_, id) {
      return http(`/quiktips/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/quiktips/${id}`, { method: 'PUT', data })
        : http('/quiktips', { method: 'POST', data });
      return request.then((response) => response.body);
    },

    // 取得tab
    getTabs({ commit }, buId) {
      return http(`/quiktips/tabs/${buId}`)
        .then((response) => response.body)
        .then(typeAs('QuikTip'))
        .then((response) => {
          commit('SET_TABS', response);
          return response;
        });
    },
    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/quiktips/${id}/status`, { method: 'PUT', data });
      return request.then((response) => response.body);
    },
    changeIsTop(_, id) {
      const request = http(`/quiktips/${id}/is_top`, { method: 'PUT' });
      return request.then((response) => response.body);
    },
  },
};
